import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/client/components/page-header";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { ComunicacaoClient } from "@/client/modules/comunicacao/comunicacao-client";
import Loading from "@/client/modules/comunicacao/loading";

export const Route = createFileRoute("/app/comunicacao")({
  loader: ({ context }) => ensurePage(context.queryClient, apiQuery("comunicacao", "page", {})),
  head: () => pageHead("Comunicação"),
  pendingComponent: Loading,
  component: ComunicacaoPage,
});

function ComunicacaoPage() {
  const { data } = useApiSuspenseQuery("comunicacao", "page", {});
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader
        title="Comunicação"
        description="Disparos de WhatsApp pendentes — lembrete e confirmação de consulta."
      />
      <ComunicacaoClient atrasados={data.atrasados} hoje={data.hoje} proximos={data.proximos} />
    </div>
  );
}
